import RouteTemplate from 'ember-route-template';

export default RouteTemplate(<template>{{outlet}}</template>);
